import React from 'react';
import VideoLinkPageTemplate from './VideoLinkPageTemplate';
import ProjectDetails from './ProjectDetails';

function Breathe() {
  const title = "BREATHE (2025)";
  const subtitle = "Short Film, 7mins";
  const description = "A young man grappling with the death of his brother, learns to confront his pain and comfort his innocent sister, finding unexpected solace in their shared vulnerability.";
  const videoSrc = 'https://player.vimeo.com/video/1096765688?h=1c817d489f';

  const credits = [
    { role: "Directors", name: "KENNETH NGUYEN and JADEN KILKENNY" },
    { role: "Producer", name: "ROWAN ROSENBLUM" },
    { role: "Music", name: "ARYAN MEDAM" },
    { role: "Editor", names: ["KENNETH NGUYEN"] }
  ];

  const keycast = [
    { role: "Kieran", name: "JADEN KILKENNY" },
    { role: "Ruby", name: "SUMMER SERAFIM" },
    { role: "Soraya", name: "PEIGHTON BROWN" },
    { role: "Father", name: "TERRELL HILL" },
    { role: "Mother", name: "LATOYA JACKSON" }
  ];

  const festivals = [
    { name: "Richmond Film Network 2025", note: "Official Selection" }
  ];

  return (
    <div>
      <VideoLinkPageTemplate
        title={title}
        subtitle={subtitle}
        description={description}
        videoSrc={videoSrc}
      />
      
      <ProjectDetails festivals={festivals} credits={credits} cast={keycast} />

    </div>
  );
}

export default Breathe;
